export interface ContentWarning {
  label: string;
  description: string;
}

export const contentWarnings: ContentWarning[] = [
  { label: 'WT-G (General)', description: 'Suitable for all audiences.' },
  { label: 'WT-PG (Parental Guidance)', description: 'May contain mild themes, violence, or horror themes.' },
  { label: 'WT-13 (Teen+)', description: 'May contain moderate violence, explicit horror, or mature concepts.' },
  { label: 'WT-M (Mature)', description: 'May contain intense violence, explicit themes, or strong language.' },
  { label: 'WT-A (Adult)', description: 'May contain extreme violence or highly disturbing material.' }
];
